import { render, staticRenderFns } from "./SetPasswordSuccess.vue?vue&type=template&id=281ce54b&scoped=true&"
import script from "./SetPasswordSuccess.vue?vue&type=script&lang=js&"
export * from "./SetPasswordSuccess.vue?vue&type=script&lang=js&"
import style0 from "./SetPasswordSuccess.vue?vue&type=style&index=0&id=281ce54b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281ce54b",
  null
  
)

export default component.exports